import { useLocation } from "@tanstack/react-router";
import { observer } from "mobx-react-lite";
import { type PropsWithChildren } from "react";

import { useAuthContext } from "src/auth/AuthContext";
import { RootMain } from "src/components/RootLayoutRootMain";

import { AuthLayout } from "../layout/AuthLayout";
import { useLayoutSettingsContext } from "../layout/LayoutSettingsContext";
import { UpgradePaywall } from "../layout/UpgradePaywall";

export const Children = observer(function Children(props: PropsWithChildren) {
  const authContext = useAuthContext();
  const location = useLocation();
  const layoutSettings = useLayoutSettingsContext();

  if (
    layoutSettings.useAuthLayout === false ||
    location.pathname === "/payment-success" ||
    location.pathname.startsWith("/shared")
  ) {
    return <RootMain>{props.children}</RootMain>;
  }

  if (
    authContext.store.isCoach &&
    !authContext.store.hasCoachSubscriptionAccess &&
    layoutSettings.requiresCoachSubscription !== false
  ) {
    return (
      <RootMain>
        <UpgradePaywall />
      </RootMain>
    );
  }

  if (authContext.store.isAuthenticated) {
    return (
      <AuthLayout
        navigationTitle={layoutSettings.authNavigationTitle}
        showSidebar={layoutSettings.showAuthSidebar}
      >
        {props.children}
      </AuthLayout>
    );
  }

  return <RootMain>{props.children}</RootMain>;
});
